import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";

function Counters() {
  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} md={4}>
            <DefaultCounterCard count={1} title="Modalidad" description="modalidad Virtual" />
          </Grid>
          <Grid item xs={12} md={4} display="flex" alignItems="center" justifyContent="center">
            <Divider
              orientation="vertical"
              flexItem
              sx={{ display: { xs: "none", md: "block" } }}
            />
            <DefaultCounterCard
              prefix="+"
              count={10}
              title="Expertos Internacionales"
              description="Conferencistas y panelistas líderes en la industria"
            />

            <Divider
              orientation="vertical"
              flexItem
              sx={{ display: { xs: "none", md: "block" } }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={3}
              suffix=""
              title="días"
              description="Con conferencias, paneles y talleres
Sesiones prácticas sobre innovación, calidad, e inteligencia artificial
"
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Counters;
